import { render, staticRenderFns } from "./SiteMessageBanner.vue?vue&type=template&id=1de65f8e&lang=pug"
import script from "./SiteMessageBanner.vue?vue&type=script&lang=js"
export * from "./SiteMessageBanner.vue?vue&type=script&lang=js"
import style0 from "./SiteMessageBanner.vue?vue&type=style&index=0&id=1de65f8e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports